import type { Box } from '$lib/types/Components/SharedTypes';

export const getBgStyles = (bgImage: Box['bgImage']) => {
    const { visible, src, focalPoint, opacity } = bgImage || {};

    return `background-image: ${visible ? `url(${src})` : ''}; opacity: ${
        opacity && !isNaN(opacity) ? opacity / 100 : 0
    }; background-position: ${focalPoint ? `${focalPoint.x}% ${focalPoint.y}%` : 'center'};`;
};
